import { Box, Container, Typography, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid2";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { requestGetAll } from "../API/request_server";
import Message from "./Message";

const ImageSlider = () => {
  const [_images, _setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const getData = async () => {
    const result = await requestGetAll("sliders/getall");

    const data = result.data.map((item) => ({
      slider_title: item.slider_title,
      image: item.image
        ? `https://ptp.gkp.pk/backend_ptp_admin/${item.image}`
        : "favicon.ico",
    }));

    _setImages(data);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (_images.length === 0) return;

    const interval = setInterval(() => {
      handleNext();
    }, 5000);

    return () => clearInterval(interval);
  }, [_images, currentIndex]);

  const changeSlide = (newIndex) => {
    setFade(false);

    setTimeout(() => {
      setCurrentIndex(newIndex);
      setFade(true);
    }, 300);
  };

  const handleNext = () => {
    const nextIndex =
      currentIndex === _images.length - 1 ? 0 : currentIndex + 1;

    changeSlide(nextIndex);
  };

  const handlePrev = () => {
    const prevIndex =
      currentIndex === 0 ? _images.length - 1 : currentIndex - 1;

    changeSlide(prevIndex);
  };

  return (
    <Box sx={{ width: "100%", m: 0, p: 0 }}>
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          m: 0,
          p: 0,
        }}
      >
        <Grid container spacing={0}>
          <Grid size={{ xs: 12 }}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: { xs: 250, md: 500 },
                overflow: "hidden",
                borderRadius: 0,
                m: 0,
                p: 0,
              }}
            >
              <Box
                component="img"
                src={_images[currentIndex]?.image}
                alt="slider"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "all 0.6s ease-in-out",
                  opacity: fade ? 1 : 0,
                  transform: fade ? "scale(1)" : "scale(1.05)",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  width: "100%",
                  background: "rgba(0,0,0,0.5)",
                  color: "#fff",
                  padding: "20px",
                }}
              >
                <Typography
                  fontWeight="bold"
                  align="center"
                  sx={{
                    fontSize: { xs: "10px", md: "24px" },
                    textShadow: "2px 2px 10px rgba(0,0,0,0.5)",
                  }}
                >
                  {_images[currentIndex]?.slider_title}
                </Typography>
              </Box>
              <IconButton
                onClick={handlePrev}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: 15,
                  transform: "translateY(-50%)",
                  bgcolor: "rgba(255,255,255,0.2)",
                  backdropFilter: "blur(5px)",
                  color: "#fff",
                  "&:hover": {
                    bgcolor: "rgba(255,255,255,0.4)",
                  },
                }}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
              <IconButton
                onClick={handleNext}
                sx={{
                  position: "absolute",
                  top: "50%",
                  right: 15,
                  transform: "translateY(-50%)",
                  bgcolor: "rgba(255,255,255,0.2)",
                  backdropFilter: "blur(5px)",
                  color: "#fff",
                  "&:hover": {
                    bgcolor: "rgba(255,255,255,0.4)",
                  },
                }}
              >
                <ArrowForwardIosIcon />
              </IconButton>

              {/* Dots */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 15,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                {_images.map((_, index) => (
                  <Box
                    key={index}
                    onClick={() => changeSlide(index)}
                    sx={{
                      width: currentIndex === index ? 24 : 10,
                      height: 10,
                      borderRadius: 5,
                      bgcolor:
                        currentIndex === index
                          ? "#fff"
                          : "rgba(255,255,255,0.5)",
                      transition: "0.3s",
                      cursor: "pointer",
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Grid>

          {/* <Grid size={{ xs: 12, md: 4 }}>
            <Message />
          </Grid> */}
        </Grid>
      </Container>
    </Box>
  );
};

export default ImageSlider;
